import { AdminEmployee } from "@workspace/admin-domain/src/features/employee/schema";
import { t } from "i18next";
import * as z from "zod";

export const EMPLOYEE_SORT_OPTIONS: {
  label: string;
  kv: `${AdminEmployee["SortBy"][number]}_${AdminEmployee["SortOrder"][number]}`;
  value: {
    key: AdminEmployee["SortBy"][number];
    order: AdminEmployee["SortOrder"][number];
  };
}[] = [
  {
    label: t("employees.sort.name_asc"),
    kv: "name_asc",
    value: { key: "name", order: "asc" },
  },
  {
    label: t("employees.sort.name_desc"),
    kv: "name_desc",
    value: { key: "name", order: "desc" },
  },

  {
    label: t("employees.sort.phone_asc"),
    kv: "phone_asc",
    value: { key: "phone", order: "asc" },
  },
  {
    label: t("employees.sort.phone_desc"),
    kv: "phone_desc",
    value: { key: "phone", order: "desc" },
  },
  {
    label: t("employees.sort.role_asc"),
    kv: "roleId_asc",
    value: { key: "roleId", order: "asc" },
  },
  {
    label: t("employees.sort.role_desc"),
    kv: "roleId_desc",
    value: { key: "roleId", order: "desc" },
  },
  {
    label: t("employees.sort.isActive_asc"),
    kv: "isActive_asc",
    value: { key: "isActive", order: "asc" },
  },
  {
    label: t("employees.sort.isActive_desc"),
    kv: "isActive_desc",
    value: { key: "isActive", order: "desc" },
  },
  {
    label: t("employees.sort.createdAt_asc"),
    kv: "createdAt_asc",
    value: { key: "createdAt", order: "asc" },
  },
  {
    label: t("employees.sort.createdAt_desc"),
    kv: "createdAt_desc",
    value: { key: "createdAt", order: "desc" },
  },
] as const;

export const DEFAULT_EMPLOYEES_PARAMS = {
  page: 0,
  limit: 10,
  sortBy: "createdAt",
  sortOrder: "desc",
} satisfies AdminEmployee["GetAll"];

export const EmployeeFiltersSchema = AdminEmployee.GetAll.partial({
  page: true,
  limit: true,
  sortBy: true,
  sortOrder: true,
});
export type EmployeeFiltersSchema = z.infer<typeof EmployeeFiltersSchema>;
